/**
 * 匿名ホットライン 企業規模 10億円以下
 */
export const HOTLINE_SALES_UNDER_10_BILLION = {
    label: '10億円以下',
    value: 1,
};
/**
 * 匿名ホットライン 企業規模 10〜100億円
 */
export const HOTLINE_SALES_BETWEEN_10_AND_100_BILLION = {
    label: '10〜100億円',
    value: 2,
};
/**
 * 匿名ホットライン 企業規模 100〜500億円
 */
export const HOTLINE_SALES_BETWEEN_100_AND_500_BILLION = {
    label: '100〜500億円',
    value: 3,
};
/**
 * 匿名ホットライン 企業規模 500〜1000億円
 */
export const HOTLINE_SALES_BETWEEN_500_AND_1000_BILLION = {
    label: '500〜1000億円',
    value: 4,
};
/**
 * 匿名ホットライン 企業規模 1000〜5000億円
 */
export const HOTLINE_SALES_BETWEEN_1000_AND_5000_BILLION = {
    label: '1000〜5000億円',
    value: 5,
};
/**
 * 匿名ホットライン 企業規模 5000〜1兆円
 */
export const HOTLINE_SALES_BETWEEN_5000_AND_1_TRILLION = {
    label: '5000〜1兆円',
    value: 6,
};
/**
 * 匿名ホットライン 企業規模 1兆円以上
 */
export const HOTLINE_SALES_ABOVE_1_TRILLION = {
    label: '1兆円以上',
    value: 7,
};
/**
 * 匿名ホットライン 企業規模 一覧
 */
export const HOTLINE_SALES = [
    HOTLINE_SALES_UNDER_10_BILLION,
    HOTLINE_SALES_BETWEEN_10_AND_100_BILLION,
    HOTLINE_SALES_BETWEEN_100_AND_500_BILLION,
    HOTLINE_SALES_BETWEEN_500_AND_1000_BILLION,
    HOTLINE_SALES_BETWEEN_1000_AND_5000_BILLION,
    HOTLINE_SALES_BETWEEN_5000_AND_1_TRILLION,
    HOTLINE_SALES_ABOVE_1_TRILLION,
];
/**
 * 匿名ホットライン 企業規模 値一覧
 */
export const HOTLINE_SALES_VALUES = HOTLINE_SALES.map((v) => v.value);
